import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetPortalFeaturesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetPortalFeaturesQuery = { __typename?: 'query_root', features: Array<{ __typename?: 'features', id: number, name: string, label: string, description: string, category_id?: number | null, config: object }> };


export const GetPortalFeaturesDocument = gql`
    query GetPortalFeatures {
  features(where: {application: {_eq: "portal"}}, order_by: {name: asc}) {
    id
    name
    label
    description
    category_id
    config
  }
}
    `;

/**
 * __useGetPortalFeaturesQuery__
 *
 * To run a query within a React component, call `useGetPortalFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortalFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortalFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPortalFeaturesQuery(baseOptions?: Apollo.QueryHookOptions<GetPortalFeaturesQuery, GetPortalFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortalFeaturesQuery, GetPortalFeaturesQueryVariables>(GetPortalFeaturesDocument, options);
      }
export function useGetPortalFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPortalFeaturesQuery, GetPortalFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortalFeaturesQuery, GetPortalFeaturesQueryVariables>(GetPortalFeaturesDocument, options);
        }
// @ts-ignore
export function useGetPortalFeaturesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPortalFeaturesQuery, GetPortalFeaturesQueryVariables>): Apollo.UseSuspenseQueryResult<GetPortalFeaturesQuery, GetPortalFeaturesQueryVariables>;
export function useGetPortalFeaturesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPortalFeaturesQuery, GetPortalFeaturesQueryVariables>): Apollo.UseSuspenseQueryResult<GetPortalFeaturesQuery | undefined, GetPortalFeaturesQueryVariables>;
export function useGetPortalFeaturesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPortalFeaturesQuery, GetPortalFeaturesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPortalFeaturesQuery, GetPortalFeaturesQueryVariables>(GetPortalFeaturesDocument, options);
        }
export type GetPortalFeaturesQueryHookResult = ReturnType<typeof useGetPortalFeaturesQuery>;
export type GetPortalFeaturesLazyQueryHookResult = ReturnType<typeof useGetPortalFeaturesLazyQuery>;
export type GetPortalFeaturesSuspenseQueryHookResult = ReturnType<typeof useGetPortalFeaturesSuspenseQuery>;
export type GetPortalFeaturesQueryResult = Apollo.QueryResult<GetPortalFeaturesQuery, GetPortalFeaturesQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/userManagement/queries/getPortalFeatures.query.gql}
 */
export async function getPortalFeatures(
  variables: GetPortalFeaturesQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetPortalFeaturesQuery['features']>
export async function getPortalFeatures(
  variables: GetPortalFeaturesQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetPortalFeaturesQuery>
export async function getPortalFeatures(
  variables: GetPortalFeaturesQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetPortalFeaturesQuery['features'] | GetPortalFeaturesQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetPortalFeaturesQuery>(
    GetPortalFeaturesDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.features
}